module.exports = __webpack_public_path__ + "static/media/bar_logo.fcb59bb6.svg";